import {
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import React, { FC } from 'react'
import { STYLE_VARS } from '../../../constants/style-vars';
import { Button } from '../../../components/Button';
import { NavigationService } from '../../../services/navigation';
import { FONTS } from '../../../constants';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { IS_WEB } from '../../../constants/platform';
import { INotice } from '../../../types/notices.types';
import { htmlDecode } from '../../../services/utils/htmlDecode';
import dayjs from 'dayjs';

interface NoticeItemProps {
  item: INotice;
}
const lorem =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';
const NoticeItem: FC<NoticeItemProps> = ({ item }) => {
  function extractUrlFromHtml(htmlString: string): string | null {
    const regex = /href="([^"]*)"/;
    const match = regex.exec(htmlString);
    const url = match ? match[1] : null;
    return url;
  }
  const isDesktop = useIsDesktop();

  return (
    <View style={styles.wrapper}>
      <View style={{
        flexDirection: isDesktop() ? "row" : "column",
        flexWrap: "wrap",
        justifyContent: "space-between",
        gap: 10,
      }}>
        <View style={isDesktop() && { width: "70%" }}>
          <View style={isDesktop() && { marginBottom: 15 }}>
            <TouchableOpacity
              onPress={() => {
                NavigationService.push<'NoticeDetail'>('NoticeDetail', {
                  id: item.id,
                });
              }}
            >
              <Text style={styles.title} numberOfLines={2}>{item.title}</Text>
            </TouchableOpacity>
          </View>
          {!isDesktop() && (
            <View style={{ paddingVertical: 10 }}>
              <Text style={styles.dayText}>{dayjs(new Date(item.date*1000)).format('MMM DD, YYYY')}</Text>
            </View>
          )}
          <View style={styles.horizontalLine} />
          <View style={{ marginVertical: 10 }}>
            <TouchableOpacity
              onPress={() => {
                NavigationService.push<'NoticeDetail'>('NoticeDetail', {
                  id: item.id,
                });
              }}
            >
              <Text style={styles.dayText} numberOfLines={3}>
                {htmlDecode(item.content)}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
        <View
          style={[
            {
              alignSelf: "stretch",
              flexDirection: 'column',
            },
            isDesktop() && { width: "20%" }
          ]}
        >
          {isDesktop() && (
            <View>
              <Text
                style={{
                  fontFamily: FONTS.AvenirMedium,
                  fontSize: 16,
                  fontWeight: "500",
                  textTransform: "uppercase",
                  color: STYLE_VARS.fccDarkerGrey,
                }}
              >{dayjs(new Date(item.date*1000)).format('MMM DD, YYYY')}</Text>
            </View>
          )}
          <View
            style={{
              flexDirection: "row",
              alignItems: 'center',
              gap: 10,
              marginTop: "auto"
            }}
          >
            <Button
              text="READ MORE"
              style={STYLE_VARS.blueButton}
              onPress={() => {
                //Linking.openURL(extractUrlFromHtml(item.content) || '');
                NavigationService.push<'NoticeDetail'>('NoticeDetail', {
                  id: item.id,
                });
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

export default NoticeItem;

const styles = StyleSheet.create({
  wrapper: {
    paddingVertical: 20,
    borderBottomColor: STYLE_VARS.fccDarkGrey,
    borderBottomWidth: 1,
    width: '100%',
  },
  title: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 18,
    fontWeight: '500',
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
  },
  dayText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 13,
    fontWeight: '500',
    color: STYLE_VARS.fccDarkerGrey,
    textTransform: 'uppercase',
  },
  horizontalLine: {
    width: 30,
    height: 3,
    backgroundColor: STYLE_VARS.primaryColor,
  },
});
